/**
 * @file contains the function to override the safe area CSS variables when within a webview
 */
import { getIsReactNativeWebView } from '../utils/webview/helpers';

/**
 * Override the safe area CSS variables when within a webview
 */
export const overrideSafeAreaVariables = () => {
  const isWebview = getIsReactNativeWebView();

  /**
   * If we're not in a webview, the variables are already set correctly
   */
  if (isWebview === false) {
    return;
  }

  /**
   * When we're in a webview, the safe area is already included,
   * as the native app uses SafeAreaView,
   * so we don't want to apply any additional insets
   */
  document.documentElement.style.setProperty('--safe-area-inset-top', '0px');
  document.documentElement.style.setProperty('--safe-area-inset-bottom', '0px');
  document.documentElement.style.setProperty('--safe-area-inset-left', '0px');
  document.documentElement.style.setProperty('--safe-area-inset-right', '0px');
};
